import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const FCCData = ['Jan 2024', 'Feb 2024', 'Mar 2024', 'Apr 2024', 'May 2024', 'Jun 2024', 'Aug 2024', 'Dec 2024']

function DataFilter({ selectedData, onDataChange }) {
  return (
    <FormControl variant="outlined" fullWidth sx={{ marginLeft: '20px', width: '150px'}}>
      <InputLabel id="dataSelect-label" >Select FCC Data</InputLabel>
      <Select
        labelId="dataSelect-label"
        id="dataSelect"
        value={(selectedData)}
        onChange={onDataChange}
        label="Select FCC Data"
      >
      
        {FCCData.map((fccDate) => {
          // Conditionally render "Vermont" based on the includeVermont prop
          /*if (stateFullName === 'Vermont' && !includeVermont) {
            return null;
          }*/
          return (
            <MenuItem key={fccDate} value={fccDate}>
              {fccDate}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default DataFilter;
